import React from "react";
import { Link } from "react-router-dom";
import Carousel from "../components/carousel";
import { usePlaylist, useCollection } from "../hooks/useInventory";
import useInView from "../hooks/useInView";
import { Tile } from "../components/views";
import Parse, { domToReact } from "html-react-parser";
import URI from "urijs";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Block = ({ block }) => {
  const classes = "block ";

  if (!block || !block.data) return null;

  switch (block.type) {
    case "text":
      return (
        <div className={classes + "text paragraph"} dangerouslySetInnerHTML={{ __html: block.data.content }} />
      );
    case "embed": {
      const replace = (domNode) => {
        if (domNode.name === "a" && domNode.attribs.href && !(new URI(domNode.attribs.href).is("absolute"))) {
          return <Link to={domNode.attribs.href}>{domToReact(domNode.children)}</Link>;
        } else domToReact(domNode);
      };
      return (
        <div className={classes + "embed"}>
          {Parse(block.data.html || "", { replace })}
        </div>
      );
    }
    case "separator":
      return (
        <div className={classes + "separator"}>
          <hr />
        </div>
      );
    case "carousel":
      return (
        <div className={classes + "images carousel"}>
          <Carousel block={block} />
        </div>
      );
    case "playlist":
      return (<PlaylistBlock block={block} />);
    case "subscribe": {
      // const listRef = block.data.listRef || config.getProperty("newsletter", "defaultListRef");
      // if (listRef)
      //   elementsToPush.push(
      //     <SubscribeBlock config={config} t={t} listRef={listRef} addNotification={addNotification} key={index} />
      //   );
      // break;
      return <p>Subscribe</p>;
    }
    case "collection":
      return (<CollectionBlock block={block} />);
    case "image": {
      if (!block.data || !block.data.media) break;
      const link = block.data.to || block.data.link;
      const imageUrl = block.data.format && block.data.media?.formats && block.data.media?.formats[block.data.format]?.url ? block.data.media.formats[block.data.format].url : block.data.media?.url;
      if (link) {
        if (link.includes("http"))
          return (
            <a target="_blank" rel="noreferrer noopener" href={link} className={classes + "image"}>
              <LazyLoadImage src={imageUrl} />
            </a>
          );
        else
          return (
            <Link to={link} className="image">
              <LazyLoadImage src={imageUrl} />
            </Link>
          );
      } else
        return (
          <div className={"image"}>
            <LazyLoadImage src={imageUrl} />
          </div>
        );
    }
    default: return null;
  }
};

const PlaylistBlock = ({ block }) => {
  const [ref, onScreen] = useInView();
  const { loading, playlist } = usePlaylist({ id: block.data.id, isInView: onScreen });

  if (playlist === null) return null;

  return (
    <div ref={ref} className="block playlist">
      {playlist && !loading ? <div className='content'>
          <div className="header">
            <h2>{playlist.link ? <Link to={playlist.link}>{playlist.title}</Link> : playlist.title}</h2>
          </div>
          <div className="entries">
            {playlist.entries.map((e, i) => (
              <Tile key={i} item={e.item} />
            ))}
          </div>
        </div> : null }
    </div>
  );
};

const CollectionBlock = ({ block }) => {
  const [ref, onScreen] = useInView();
  const { collection, loading } = useCollection({ id: block.data.id, isOnScreen: onScreen });

  if (!collection || loading) return null;

  const link = `/collection/${collection?.collection?.handle}?sort=${block.data.sort}&order=${block.data.order}`;

  return (
    <div ref={ref} className="block collection">
      <div className="content">
        <div className="header">
          <Link className="seeMore" to={link}><h2>{collection.collection.title}</h2></Link>
        </div>
        <div className="entries">
          {collection.page.items.map(e => (<Tile key={e.id} item={e} />))}
        </div>
        <div className="footer">
          <Link className="seeMore" to={link}>
            <button className="primary" type='button'>See more</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Block;
